import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3268f1b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-menu" }
const _hoisted_2 = { class: "logo position-absolute start-0 end-0 top-0 bg-black division-company-name" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "company-name fw-bold ms-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bb-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pie-chart-1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bar-chart-1" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Performance", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-headphones" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Gravações", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-track" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Realtime", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-settings-1" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Configurações", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-1" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Usuários", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Eventos", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-credit-card" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Pagamentos", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Documentação", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.getConfigurations.white_label_logo != null ? _ctx.getConfigurations.white_label_logo : 'https://general-sanvault-bucket.s3.us-east-2.amazonaws.com/logo/1761340970_favicon2.png',
          alt: "logo-icon",
          width: "30"
        }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.getConfigurations.white_label), 1),
        _hoisted_5,
        _createElementVNode("button", {
          class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
        }, _hoisted_7)
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_ctx.getPermissions.includes('access.dashboard'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isDashboardActive })
                  }, _hoisted_11, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.performance'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/performance",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isPerformanceActive })
                  }, _hoisted_14, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.recordings'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "gravacoes sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/recordings",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isRecordingsActive })
                  }, _hoisted_17, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.realtime'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "realtime sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/realtime",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isRealtimeActive })
                  }, _hoisted_20, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.configurations'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "configuracoes performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/operations",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isOperationsActive })
                  }, _hoisted_23, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.users'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 5,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/users",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isUsersActive })
                  }, _hoisted_26, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasWaltRegistrationsPermission)
          ? (_openBlock(), _createElementBlock("li", {
              key: 6,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "walt-registrations sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/eventos/inscricoes",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isWaltRegistrationsActive })
                  }, _hoisted_29, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.payment'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 7,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/payment",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isPaymentActive })
                  }, _hoisted_32, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.getPermissions.includes('access.documentation'))
          ? (_openBlock(), _createElementBlock("li", {
              key: 8,
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
              class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            }, [
              _createVNode(_component_router_link, {
                to: "/documentation",
                class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({ active: _ctx.isDocumentationActive })
                  }, _hoisted_35, 2)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}